import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalConfirmation } from '@/lib/v2/organisms';

import { useActionsRecurringMessage } from '@/src/modules/AutomationModuleNew/hooks/useActionsRecurringMessage';

interface DeleteActionRecurringMessageDetailModalProps {
  totalRowSelected: number;
  actionsIds: number[];
  refetchData: () => void;
  isOpen: boolean;
  onClose: () => void;
}

const DeleteActionRecurringMessageDetailModal = ({
  totalRowSelected,
  actionsIds,
  refetchData,
  isOpen,
  onClose,
}: DeleteActionRecurringMessageDetailModalProps) => {
  const { t } = useTranslation();
  const { deleteAction, isLoading } = useActionsRecurringMessage();

  const handleConfirm = useCallback(async () => {
    await deleteAction(actionsIds);
    onClose();
    refetchData();
  }, [deleteAction, actionsIds, onClose, refetchData]);

  return (
    <ModalConfirmation
      isLoading={isLoading}
      isOpen={isOpen}
      textCancelButton={t('CAMPAIGN_ACTIONS_MAIN.DELETE_ACTIONS.cancelButton')}
      textConfirmButton={t('CAMPAIGN_ACTIONS_MAIN.DELETE_ACTIONS.successButton')}
      title={
        totalRowSelected > 1
          ? t('CAMPAIGN_ACTIONS_MAIN.DELETE_ACTIONS.MULTIPLE.title')
          : t('CAMPAIGN_ACTIONS_MAIN.DELETE_ACTIONS.SINGLE.title')
      }
      onClose={onClose}
      onConfirmButton={handleConfirm}
    />
  );
};

export default DeleteActionRecurringMessageDetailModal;
